import PolicyLinks from './PolicyLinks'

export default PolicyLinks
